module.exports = __webpack_public_path__ + "static/media/md-woman.05ce5b2c.svg";